import { EQuoteError } from '@/constants/quote';
import { getIntl } from '@/utility/i18n';

// Helper function to process quote errors - extracted for testing
export const processQuoteError = (
  error: any,
  isCampsite: boolean,
  minimumStayRequirementDays?: number,
) => {
  const intl = getIntl();
  const defaultErrorMessage = intl.formatMessage({
    defaultMessage: 'Could not fetch quote. Please try again later.',
    id: 'qz2IkN',
  });

  const campsiteErrorMessage = intl.formatMessage({
    defaultMessage: 'This campsite is no longer available for the selected dates.',
    id: '87azFN',
  });

  const minimumStayErrorMessage = intl.formatMessage(
    {
      defaultMessage:
        'These dates do not meet the minimum stay requirements of {minimumStayRequirementDays} nights',
      id: 'lDlDuw',
    },
    {
      minimumStayRequirementDays,
    },
  );

  const firstError = error.errors?.[0];
  let errorMessage = firstError?.error || error.error || defaultErrorMessage;

  // Hardcoding this error message for now
  if (isCampsite && error?.original_error?.toLowerCase().includes('there is no availability')) {
    errorMessage = campsiteErrorMessage;
  }

  if (
    !isCampsite &&
    minimumStayRequirementDays &&
    error?.code === EQuoteError.MINIMUM_DAYS_LENGTH
  ) {
    errorMessage = minimumStayErrorMessage;
  }

  if (error?.code === EQuoteError.BOOKING_ADVANCE_NOTICE_REQUIRED) {
    errorMessage = error.errors?.[0]?.field || errorMessage;
  }

  return errorMessage;
};
